
export const CardToInstitutes = ({title, info}) => {
    return (
        <div className="card text-dark bg-light mb-3" style={{"max-width": "25rem"}}>
            <div className="card-header "> { title } </div>
            <div className="card-body">
                {/* <h3 className="card-title text-center">Compromiso:</h3> */}
                <p className="card-text ">{ info }</p>
            </div>
        </div>
    )
}
